import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import './DashboardTable.css';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import DashboardTableItem from './DashboardTableItem';
import { SitecoreContextReactContext } from '../../../../utils/SitecoreContextReactContext';
import { getDictionaryItem, get } from '../../../../utils';
import { getSessionId } from '../../../DAcApplication/utils';
import Loader from '../../../DAcApplication/components/loader';
import InjectHTML from '../../../DAcCreateAccount/components/InjectHTML';
import DashboardEmpty from './DashboardEmpty';
var DashboardItems = [{
  ApplicationNo: '23WA23445',
  ApplicantName: {
    EN: 'Juan Dela Cruz Manalo',
    AR: 'Juan Dela Cruz Manalo'
  },
  CreatedDate: '22-11-2024',
  StatusId: 'DRAFT',
  StatusName: {
    EN: 'Test 1',
    AR: 'Test 1 AR'
  }
}, {
  ApplicationNo: '23WA23445',
  ApplicantName: {
    EN: 'Juan Dela Cruz Manalo',
    AR: 'Juan Dela Cruz Manalo'
  },
  CreatedDate: '22-11-2024',
  StatusId: 'PAYMENTINITIATED',
  StatusName: {
    EN: 'Test 2',
    AR: 'Test 2 AR'
  }
}, {
  ApplicationNo: '23WA23445',
  ApplicantName: {
    EN: 'Juan Dela Cruz Manalo',
    AR: 'Juan Dela Cruz Manalo'
  },
  CreatedDate: '22-11-2024',
  StatusId: 'COMPLETE',
  StatusName: {
    EN: 'Test 2',
    AR: 'Test 2 AR'
  }
}, {
  ApplicationNo: '23WA23445',
  ApplicantName: {
    EN: 'Juan Dela Cruz Manalo',
    AR: 'Juan Dela Cruz Manalo'
  },
  CreatedDate: '22-11-2024',
  StatusId: 'REJECTED',
  StatusName: {
    EN: 'Test 3',
    AR: 'Test 3 AR'
  }
}, {
  ApplicationNo: '23WA23445',
  ApplicantName: {
    EN: 'Juan Dela Cruz Manalo',
    AR: 'Juan Dela Cruz Manalo'
  },
  CreatedDate: '22-11-2024',
  StatusId: 'ADDITIONALDOCREQUIRED',
  StatusName: {
    EN: 'Test 4',
    AR: 'Test 4 AR'
  }
}, {
  ApplicationNo: '23WA23445',
  ApplicantName: {
    EN: 'Juan Dela Cruz Manalo',
    AR: 'Juan Dela Cruz Manalo'
  },
  CreatedDate: '22-11-2024',
  StatusId: 'INPROCESS',
  StatusName: {
    EN: 'Test 5',
    AR: 'Test 5 AR'
  }
}, {
  ApplicationNo: '22410101129122',
  ApplicantName: {
    EN: 'Juan Dela Cruz Manalo',
    AR: 'Juan Dela Cruz Manalo'
  },
  CreatedDate: '22-11-2024',
  StatusId: 'APPROVED',
  StatusName: {
    EN: 'Test 6',
    AR: 'Test 6 AR'
  }
}];
var TOKKEN = "Bearer%20eyJhbGciOiJIUzI1NiIsImtpZCI6IkY3QzdERTM0N0FFNEI5OEUyNDQ4NjMyQjk4Qzc0NjQ0M0Y2OUFDMjBEODc0MDU1RjVFMTBDQjRFRTI0QjZDMUQiLCJ0eXAiOiJKV1QifQ.eyJzdWIiOiI4NUQ2NUNENzY2ODMxMzM0RjY0QzZCQTQ0OUNDM0I4OTc2NDkxREI2QjIzRDZENzgwNDQ2RUU5QzBCMTIxNzc4IiwianRpIjoiZUhuVVdWYUY5dy9VdlJWaTc3NGw1eHIzMlZqTmVBSG95aUpiWmduTEdVbmF1MmJxRTE1L1JjSHh1MmlxVThUUjFtMExLNCt1YTB3a0hSZHcyalc1MUEiLCJ1c2VyVHlwZSI6InVzZXIiLCJpc0luZGl2aWR1YWwiOiJUcnVlIiwidXNlclB1YmxpY0lkIjoiM2NiYzg0OTgtODE0Yy00M2QxLWJhMDItZWUyN2IwMTdmNjhjIiwidXNlcm5hbWUiOiJyYXNobWkucmFqcHV0MSIsImVpZGEiOiIiLCJuYmYiOjE3Mzc5NzI0MTEsImV4cCI6MTczODA1ODgxMSwiaWF0IjoxNzM3OTcyNDExLCJpc3MiOiJFOUU2ODg4Q0YzMUZGM0QwQTRGOEM0ODYyOEVDMjg4OTA5MzY0ODIwM0E0N0I1RDZEQTBGMTNFQjAyQjdFNjUwIiwiYXVkIjoiMzRDMEExRjUxNTk2N0UzRjE3NzQ5MDhCN0U4QzU0MzY5Mjk2QTFDQThGNUZDNjRFNDA3RkM4RTJEMDk0NUI5QSJ9.2qk_L9zAQT8gqMWZdEwuEhSIGBi9mARjEVTV-VZcGqg";
var DashboardTable = function DashboardTable(props) {
  var dictionary = props.dictionary,
    settings = props.settings,
    configuration = props.configuration,
    getAppStatus = props.getAppStatus;
  var DashboardTableHeader = [getDictionaryItem(dictionary, 'applicationNo'), getDictionaryItem(dictionary, 'applicantName'), getDictionaryItem(dictionary, 'createdOn'), getDictionaryItem(dictionary, 'status'), getDictionaryItem(dictionary, 'actions')];
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var sessionId = getSessionId('dashboard');
  var apiKey = get(settings, 'apiKey.jss.value');
  var apiUrl = get(settings, 'apiUrl.jss.value');
  var loginPage = get(settings, 'loginPage.jss.value.href');
  var history = useHistory();
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    userTokken = _useState2[0],
    setUserTokken = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    username = _useState4[0],
    setUsername = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isLoadingMore = _useState8[0],
    setIsLoadingMore = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    applicationTotalCount = _useState10[0],
    setApplicationTotalCount = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    applicationList = _useState12[0],
    setApplicationList = _useState12[1];
  var _useState13 = useState(1),
    _useState14 = _slicedToArray(_useState13, 2),
    page = _useState14[0],
    setPage = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    authFailed = _useState16[0],
    setAuthFailed = _useState16[1];
  var searchApplications = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var url, headers, data, requestOptions;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setAuthFailed('');
            applicationList.length > 0 ? setIsLoadingMore(true) : setIsLoading(true);
            url = "".concat(apiUrl, "/v1/proxy/inquiry/individual/application/search");
            headers = new Headers();
            headers.append('X-Request-Id', sessionId);
            headers.append('Apikey', apiKey);
            headers.append('Accept', 'application/json');
            headers.append('Content-Type', 'application/json');
            headers.append('Authorization', userTokken || TOKKEN);
            headers.append('Host', 'dacqa.detsandbox.com');
            headers.append('User-Agent', 'Apidog/1.0.0 (https://apidog.com)');
            data = {
              ApplicationNo: '',
              pageNumber: page,
              pageSize: 50,
              statusIds: '',
              includeService: '',
              excludeService: ''
            };
            requestOptions = {
              method: 'POST',
              headers: headers,
              redirect: 'follow',
              keepalive: true,
              withCredentials: true,
              body: JSON.stringify(data)
            };
            _context.next = 15;
            return fetch(url, requestOptions).then(function (response) {
              if (response.status == 401) {
                Cookies.remove('token');
                Cookies.remove('username');
                history.push(loginPage);
                return false;
              }
              return response.json();
            }).then(function (result) {
              if (result.hasOwnProperty('desc')) {
                setAuthFailed(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
              }
              if (result.hasOwnProperty('ApplicationList')) {
                setApplicationList([].concat(_toConsumableArray(applicationList), _toConsumableArray(result.ApplicationList)));
                setApplicationTotalCount(result.TotalCount);
              }
            }).catch(function (error) {
              console.error('searchApplications error', error);
            }).finally(function () {
              setIsLoading(false);
              setIsLoadingMore(false);
            });
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function searchApplications() {
      return _ref.apply(this, arguments);
    };
  }();
  var _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    totalApplicants = _useState18[0],
    setTotalApplicants = _useState18[1];
  var getUserStatus = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var url, headers, requestOptions;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            url = "".concat(apiUrl, "/v1/orc/user/").concat(username, "/status");
            headers = new Headers();
            headers.append('X-Request-Id', sessionId);
            headers.append('Apikey', apiKey);
            headers.append('Accept', 'application/json');
            headers.append('Content-Type', 'application/json');
            headers.append('Authorization', userTokken || TOKKEN);
            headers.append('Host', 'dacqa.detsandbox.com');
            headers.append('User-Agent', 'Apidog/1.0.0 (https://apidog.com)');
            requestOptions = {
              method: 'GET',
              headers: headers,
              redirect: 'follow',
              keepalive: true,
              withCredentials: true
            };
            _context2.next = 12;
            return fetch(url, requestOptions).then(function (response) {
              if (response.status == 401) {}
              return response.json();
            }).then(function (result) {
              if (result.hasOwnProperty('desc')) {
                console.error(rtl && result.desc.ar ? result.desc.ar : result.desc.en || '');
              }
              if (result.hasOwnProperty('totalApplicants')) {
                setTotalApplicants(result.totalApplicants);
              }
            }).catch(function (error) {
              console.error('User Status error', error);
            }).finally(function () {
              setIsLoading(false);
              setIsLoadingMore(false);
            });
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getUserStatus() {
      return _ref2.apply(this, arguments);
    };
  }();
  var loadMore = function loadMore() {
    setPage(function (prevState) {
      return prevState + 1;
    });
  };
  useEffect(function () {
    var tokken = Cookies.get('token');
    var userNameCookie = Cookies.get('username');
    if (userNameCookie) setUsername(userNameCookie);
    if (!tokken) {
      history.push(loginPage);
    } else {
      setUserTokken(tokken);
    }
  }, []);
  useEffect(function () {
    if (userTokken) {
      searchApplications();
      getUserStatus();
    }
  }, [userTokken, page]);
  useEffect(function () {
    getAppStatus({
      available: totalApplicants,
      existing: applicationTotalCount
    });
  }, [applicationTotalCount, totalApplicants]);
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table ".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, isLoading ? /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center py-5 mt-5 dashboard-loader"
  }, /*#__PURE__*/React.createElement(Loader, {
    className: "dashboard-spinner"
  })) : authFailed ? /*#__PURE__*/React.createElement("b", {
    className: "auth-failed"
  }, authFailed) : applicationList.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table__header d-none d-md-flex row"
  }, DashboardTableHeader.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "dashboard-table__header-item col col-".concat(index === 1 || index === 4 ? 3 : 2),
      key: index
    }, /*#__PURE__*/React.createElement("span", null, item));
  })), /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table__body"
  }, applicationList.map(function (item, index) {
    return /*#__PURE__*/React.createElement(DashboardTableItem, {
      key: index + '_' + (item.ApplicationNo || ''),
      item: item,
      labels: DashboardTableHeader,
      dictionary: dictionary,
      settings: settings,
      configuration: configuration
    });
  })), applicationTotalCount > applicationList.length && /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table__pagination"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: loadMore,
    className: "btn btn-secondary"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      opacity: isLoadingMore ? 0 : 1
    }
  }, getDictionaryItem(dictionary, 'loadMoreButton')), isLoadingMore ? /*#__PURE__*/React.createElement(Loader, {
    className: "dashboard-spinner"
  }) : false))) : /*#__PURE__*/React.createElement(DashboardEmpty, null, /*#__PURE__*/React.createElement(InjectHTML, {
    htmlString: getDictionaryItem(dictionary, 'notApplicationsFound')
  })));
};
export default DashboardTable;
var commonStyles = "c3hhrv9";
var ltrStyles = "l11hsb5x";
var rtlStyles = "re9f7bv";